import {
  REQUEST_RESULTS,
  RECEIVE_RESULTS,
  CLEAR_QUERY_RESULTS,
  CHANGE_QUERY
} from './../search/actions';

import {
  REQUEST_LASTADJUSTMENTS,
  RECEIVE_LASTADJUSTMENTS,
  REQUEST_ANNOTATEDTEXTS,
  RECEIVE_ANNOTATEDTEXTS
} from './../home/actions';

import {
  REQUEST_ARTICLE,
  RECEIVE_ARTICLE,
  REQUEST_ARTICLE_VERSIONS,
  RECEIVE_ARTICLE_VERSIONS,
  REQUEST_ARTICLE_COMPARE,
  RECEIVE_ARTICLE_COMPARE,
} from './../articles/actions';

import {
  REQUEST_ANNOTATION,
  RECEIVE_ANNOTATION,
  REQUEST_ELEMENT_ANNOTATIONS,
  RECEIVE_ELEMENT_ANNOTATIONS,
} from './../annotations/actions';

import {
  REQUEST_STRUCTURE_VERSIONS,
  RECEIVE_STRUCTURE_VERSIONS,
  REQUEST_STRUCTURE,
  RECEIVE_STRUCTURE,
  REQUEST_STRUCTURES,
  RECEIVE_STRUCTURES,
  NO_STRUCTURE
} from '../structures/actions';

import {
  REQUEST_ELEMENT_VERSIONS,
  RECEIVE_ELEMENT_VERSIONS,
  REQUEST_ELEMENT,
  RECEIVE_ELEMENT
} from '../elements/actions';

import {
  RECEIVE_TAGS,
  REQUEST_TAGS,
} from '../tags/actions';

const localStorage = require('web-storage')().localStorage;

const LOCAL_STORAGE_SCOPE = 'react__dia__';
const LOCAL_STORAGE_EXPIRATION = 1000 * 60 * 60;

function storeLocal(key, obj, time = 0) {
  let item = {item: obj};
  if (time > 0) {
    item.expire = (new Date()).getTime() + time;
  }
  localStorage.set(`${LOCAL_STORAGE_SCOPE}${key}`, JSON.stringify(item));
}

function getLocal(key) {
  let item = null;
  try {
    item = JSON.parse(localStorage.get(`${LOCAL_STORAGE_SCOPE}${key}`));
  } catch (e) {
    // I could try
  }
  if (!item) {
    return null;
  }
  if (item.expire) {
    let curr = (new Date()).getTime();
    if (item.expire < curr) {
      return null;
    }
  }
  return item.item;
}

export function searchresults(state = {
  isFetching: false,
  didInvalidate: false,
  query: {},
  currentQuery: {},
  items: [],
  lastUpdated: null
}, action) {
  state.currentQuery = getLocal('query') || {};
  switch (action.type) {
    case CLEAR_QUERY_RESULTS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        query: {},
        items: [],
        lastUpdated: null
      });
    case CHANGE_QUERY:
      storeLocal('query', action.query, LOCAL_STORAGE_EXPIRATION); // store for an hour
      return Object.assign({}, state, {
        currentQuery: action.query
      });
    case REQUEST_RESULTS:
      storeLocal('query', action.query, LOCAL_STORAGE_EXPIRATION); // store for an hour
      return Object.assign({}, state, {
        isFetching: true,
        query: action.query,
        currentQuery: action.query,
        didInvalidate: false
      });
    case RECEIVE_RESULTS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        meta: action.meta,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

export function structures(state = {
  isFetching: false,
  didInvalidate: false,
  items: []
}, action) {
  switch (action.type) {
    case REQUEST_STRUCTURES:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case RECEIVE_STRUCTURES:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}


export function lastadjustments(state = {
  isFetching: false,
  didInvalidate: false,
  items: []
}, action) {
  switch (action.type) {
    case REQUEST_LASTADJUSTMENTS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case RECEIVE_LASTADJUSTMENTS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

export function annotatedTexts(state = {
  isFetching: false,
  didInvalidate: false,
  items: []
}, action) {
  switch (action.type) {
    case REQUEST_ANNOTATEDTEXTS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case RECEIVE_ANNOTATEDTEXTS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

let defaultStructure = () => {
  return {
    isFetching: false,
    didInvalidate: false,
    item: {
      attributes: {
        label: "",
        toc: {
          children: []
        }
      },
      relationships: {
        publication: {
          data: [
            {
              id: -1
            }
          ]
        }
      }
    }
  };
};

export function structure(state = defaultStructure(), action) {
  let structure = defaultStructure();
  switch (action.type) {
    case REQUEST_STRUCTURE:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case RECEIVE_STRUCTURE:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        item: action.item,
        lastUpdated: action.receivedAt
      });
    case NO_STRUCTURE:
      structure.item.id = action.id;
      return structure;
    default:
      return state;
  }
}

export function article(state = {
  isFetching: false,
  didInvalidate: false,
  item: {
    attributes: {
      label: "",
      content: {
        children: [],
        annotations: []

      }
    }
  }
}, action) {
  switch (action.type) {
    case REQUEST_ARTICLE:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case RECEIVE_ARTICLE:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        item: action.item,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

export function articleVersions(state = {
  isFetching: false,
  didInvalidate: false,
  item: []
}, action) {
  switch (action.type) {
    case REQUEST_ARTICLE_VERSIONS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case RECEIVE_ARTICLE_VERSIONS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        item: action.item,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

export function articleCompare(state = {
  isFetching: false,
  didInvalidate: false,
  item: {}
}, action) {
  switch (action.type) {
    case REQUEST_ARTICLE_COMPARE:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case RECEIVE_ARTICLE_COMPARE:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        item: action.item,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

export function structureVersions(state = {
  isFetching: false,
  didInvalidate: false,
  item: [],
  structureId: null
}, action) {
  switch (action.type) {
    case REQUEST_STRUCTURE_VERSIONS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false,
        structureId: action.id
      });
    case RECEIVE_STRUCTURE_VERSIONS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        item: action.item,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

export function elementVersions(state = {
  isFetching: false,
  didInvalidate: false,
  item: {}
}, action) {
  switch (action.type) {
    case REQUEST_ELEMENT_VERSIONS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case RECEIVE_ELEMENT_VERSIONS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        item: action.item,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

export function element(state = {
  isFetching: false,
  didInvalidate: false,
  item: {
    attributes: {
      label: ""
    }
  }
}, action) {
  switch (action.type) {
    case REQUEST_ELEMENT:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case RECEIVE_ELEMENT:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        item: action.item,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}

export function annotation(state = {
  isFetching: false,
  didInvalidate: false,
  item: {}
}, action) {
  switch (action.type) {
    case REQUEST_ANNOTATION:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case RECEIVE_ANNOTATION:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        item: action.item,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }

}

export function elementAnnotations(state = {
  isFetching: false,
  didInvalidate: false,
  item: [],
  elementId: null
}, action) {
  switch (action.type) {
    case REQUEST_ELEMENT_ANNOTATIONS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false,
        elementId: action.id
      });
    case RECEIVE_ELEMENT_ANNOTATIONS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        item: action.item,
        lastUpdated: action.receivedAt,
        elementId: action.id
      });
    default:
      return state;
  }

}


export function tags(state = {
  isFetching: false,
  didInvalidate: false,
  items: null
}, action) {
  switch (action.type) {
    case REQUEST_TAGS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      });
    case RECEIVE_TAGS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        lastUpdated: action.receivedAt
      });
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/modules/search/reducers.js
 **/